import styled, { css } from 'styled-components';

export const Container = styled.div`
    ${({ theme }) => css`
        max-width: 300px;
        width: 100%;
        margin: 0 auto ${theme.sizes.marginLarge}px auto;
        display: flex;
        flex-direction: column;
        align-items: center;
    `}
`;
